export enum OUTSIDE_BUSINESS_HOUR {
  WEEKEND = 'weekend',
  HOLIDAY = 'holidays'
}

export type OUTSIDE_BUSINESS_HOUR_TYPE = `${OUTSIDE_BUSINESS_HOUR}`;

export const OUTSIDE_BUSINESS_HOUR_VALUES: OUTSIDE_BUSINESS_HOUR_TYPE[] = Object.values(OUTSIDE_BUSINESS_HOUR);
